import React from "react";
import { Link } from "react-router-dom";

function Career() {
  return (
    <>
      <section className="services" id="services">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-12">
              <div className="title text-center">
                <h2>Join Our Team</h2>
              </div>
            </div>
            <div className="col-md-6 career"></div>

            <div className=" col-md-1"></div>
            <div className=" col-md-5 footer-box">
              People are our assets and our strength. We are committed to our
              employees and their progress. What you will get at Macrozion is a
              unique combination of your own career growth along with numerous
              opportunities to help our nation grow. If you think like us, then
              submit your candidature.
            </div>

            <div className="text-center">
              <Link to="/Careerform" className="btn btn-dark">
                Join us now
              </Link>
            </div>

            {/* <div>umeshh</div> */}
          </div>
        </div>
      </section>

      {/* <div id="block-bandhan-bank-content">
        <section className="sections join-team mt-5">
          <div className="splitcircle"></div>
          <div className="container-fluid">
            <div className="row no-gutters justify-content-center">
              <div className="col-xl-7">
                <div className="about_us"><b>Join Our Team</b></div>
                <p>
                  People are our assets and our strength. We are committed to
                  our employees and their progress. What you will get at
                  Macrozion is a unique combination of your own career growth
                  along with numerous opportunities to help our nation grow. If
                  you think like us, then submit your candidature.
                </p>
                <a href="/join-our-team" className="btn btn-primary">
                  Join us now
                </a>
              </div>
            </div>
          </div>
        </section> */}
    </>
  );
}

export default Career;
